<template>
<div>
    <Header title="我的沙龙" />
    <van-tabs ref="tabs" color="#7181EB" title-active-color="#7181EB" v-model="active" @click="onClickTab()">
        <van-tab :title="item" v-for="(item, index) in type" :key="index"></van-tab>
    </van-tabs>
    <div class="scrollerView">
        <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
            <salonItem v-for="(item, index) in dataSources" :key="index" :item="item" type="student" />
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </scroller>
    </div>
</div>
</template>

<script>
import Header from "../../components/Header";
import salonItem from "../../components/item/salonItem";
export default {
    /** 组件挂载 */
    components: {
        Header: Header,
        salonItem: salonItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            type: ["进行中", "已结束"],
            active: 0,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 1,
            limit: 10,
            keyword: "",
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
    },
    /** 方法 */
    methods: {
        // 点击tab
        onClickTab() {
            this.refresh();
        },
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(
                function () {
                    this.$refs.infinite.finishPullToRefresh();
                }.bind(this),
                1000
            );
        },
        // 继续请求
        infinite() {
            this.page++;
            this.requestData();
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.salon_my_salon;
            let params = {
                token: this.Lockr.get("token"),
                page: this.page,
                limit: this.limit,
                // status: 0, // 0:暂存，1审核种，2进行，3结束，4拒绝（代理商需要添）
                user_type: "student",
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.list;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page === 1) {
                    dataSourcesTemp = dataList;
                    that._dataSource = result.data.list;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList);
                    }
                }
                that.dataSources = dataSourcesTemp;
                that.$refs.infinite.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
    height: 100vh;
}

.scroller {
    background: #f8f8f8;
}

.header {
    position: relative;
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: 0.8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        margin-left: 30px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #f5f5f5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
        }

        div {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            background: #e1d9d9;
        }

        p {
            font-size: 14px;
            color: #666;
        }
    }
}
</style>
